import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { LearnMoreLink } from '../../../shared/LearnMoreLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const UnifiedMonetizationContent = ({
  use
}) => /*#__PURE__*/_jsxs(Text, {
  use: use,
  children: [/*#__PURE__*/_jsx(FormattedMessage, {
    message: "creditsAwareness.beta.icon.unified.doesntUseCreditsNow"
  }), ' ', /*#__PURE__*/_jsx(LearnMoreLink, {})]
});